import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherVM } from "@shared-kernel/application/ports/student/student-repository";
import { retrieveFavoriteTeachers } from "./retrieve-favorite-teachers";

const initialState: RetrievalState<TeacherVM[]> = { fetching: "idle", data: [] };

export const studentRetrieveFavoriteTeachersReducer = createReducer<RetrievalState<TeacherVM[]>>(initialState, builder => {
  builder.addCase(retrieveFavoriteTeachers.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveFavoriteTeachers.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveFavoriteTeachers.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
